export type TDataSectionSecondary = {
  title: string;
  descriptionPrimary: string;
  descriptionSecondary?: string;
  borderColor: string;
  iconColor: string;
  messageButton: string;
  imageUrl?: string;
  imageUrlMobile?: string;
  widthImageMobile: number;
  heightImageMobile: number;
  widthImageDesktop: number;
  heightImageDesktop: number;
  altImage: string;
  background?: boolean;
};

export const DataSectionSecondary: TDataSectionSecondary[] = [
  {
    title: 'El precio justo atrae al inquilino perfecto.',
    descriptionPrimary: 'Reduce la cantidad de tiempo en el que tu inmueble estará vacío con el precio correcto.',
    descriptionSecondary: '¡Un inmueble con el precio correcto se arrienda hasta 3 veces más rápido!',
    borderColor: '#FACD23',
    iconColor: '#FFBD11',
    messageButton: 'Encontrar el precio perfecto',
    imageUrl: '/images/landing-pages/landing-calculator/calculator02.svg',
    widthImageMobile: 516,
    heightImageMobile: 228,
    widthImageDesktop: 375,
    heightImageDesktop: 272,
    altImage: 'Encontrar el precio perfecto | Aptuno',
  },
  {
    title: 'Sin fórmulas complejas ni cálculos difíciles',
    descriptionPrimary:
      'Comparamos tu inmueble con otros similares en la zona para darte un precio actualizado y relevante.',
    borderColor: '#0055FB',
    iconColor: '#0055FB',
    messageButton: 'Ir a la calculadora',
    imageUrl: '/images/landing-pages/landing-calculator/calculator03.svg',
    widthImageMobile: 416,
    heightImageMobile: 214,
    widthImageDesktop: 375,
    heightImageDesktop: 272,
    altImage: 'Ir a la calculadora | Aptuno',
  },
  {
    title: 'No pierdas dinero  que podrías estar cobrando por tu inmueble',
    descriptionPrimary: 'Te ayudamos a maximizar el precio que podrías pedir por el arriendo de tu inmueble',
    borderColor: '#FFBD11',
    iconColor: '#FFBD11',
    messageButton: 'Encuentra el mejor precio para ti',
    widthImageMobile: 216,
    heightImageMobile: 114,
    widthImageDesktop: 375,
    heightImageDesktop: 272,
    altImage: 'Encuentra el mejor precio para ti | Aptuno',
    background: true,
  },
];
